import { useMemo, useState } from 'react';

import { useHasMapSync } from './useHasMapSync';
import {
  type InternalValue,
  type AnalyticalFieldMappingFieldType,
} from '../../bookkeep/settings/accounting';

export type FieldMappingOpenFor = {
  internalField: InternalValue;
  internalValues: InternalValue[];
  fieldType: AnalyticalFieldMappingFieldType;
  targetValueId?: string;
};

export const useAnalyticalFieldOpenFor = () => {
  const hasMapSyncFeature = useHasMapSync();
  const [fieldMappingModalOpenFor, setFieldMappingModalOpenFor] =
    useState<FieldMappingOpenFor | null>(null);
  const isFieldMappingModalOpen = useMemo(() => {
    return hasMapSyncFeature && fieldMappingModalOpenFor !== null;
  }, [hasMapSyncFeature, fieldMappingModalOpenFor]);

  const internalValues = fieldMappingModalOpenFor?.internalValues ?? [];

  return {
    isFieldMappingModalOpen,
    internalField: fieldMappingModalOpenFor?.internalField,
    internalValues: fieldMappingModalOpenFor?.targetValueId
      ? internalValues.filter(
          ({ id }) => id === fieldMappingModalOpenFor.targetValueId,
        )
      : internalValues,
    targetValueId: fieldMappingModalOpenFor?.targetValueId,
    fieldType: fieldMappingModalOpenFor?.fieldType ?? null,
    setMapping: setFieldMappingModalOpenFor,
    clearMapping: () => setFieldMappingModalOpenFor(null),
  };
};
